import { render, staticRenderFns } from "./symptomSurveyDetailOuter.vue?vue&type=template&id=5d4c6e42"
import script from "./symptomSurveyDetailOuter.vue?vue&type=script&lang=js"
export * from "./symptomSurveyDetailOuter.vue?vue&type=script&lang=js"
import style0 from "./symptomSurveyDetailOuter.vue?vue&type=style&index=0&id=5d4c6e42&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d4c6e42')) {
      api.createRecord('5d4c6e42', component.options)
    } else {
      api.reload('5d4c6e42', component.options)
    }
    module.hot.accept("./symptomSurveyDetailOuter.vue?vue&type=template&id=5d4c6e42", function () {
      api.rerender('5d4c6e42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/outer/symptomSurveyDetailOuter.vue"
export default component.exports